import template from './bot-sessions-filter.html';
import BotSessionsFilterController from './bot-sessions-filter.controller';
import './bot-sessions-filter.styl';

let botSessionsFilterComponent = {
  restrict: 'E',
  bindings: {
    applyFilters: '&'
  },
  template,
  controller: BotSessionsFilterController,
  controllerAs: 'vm'
};

export default botSessionsFilterComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/bot-sessions-filter/bot-sessions-filter.component.js
 **/